import React from 'react';
import classes from './LearnMore.css';
import { gciPageView } from '../../../lib/analytics';

const pageTitle = 'The Huddle';

class LearnMore extends React.Component {
  componentDidMount() {
    document.title = `${pageTitle} - TheHuddle`;
    gciPageView(pageTitle);
  }

  render() {
    return (
      <div className={classes.promoWrap}>
        <h1>{pageTitle}</h1>
        <p>
          The Huddle is no longer accepting new subscriptions.
          Already a member? <a href="/login">Sign in</a>
        </p>
      </div>
    );
  }
}

export default LearnMore;



// WEBPACK FOOTER //
// ./src/app/views/LearnMore/LearnMore.js